import { LitElement, html } from 'https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js';

class LitElementEjected extends LitElement {
    createRenderRoot() {
        // Returning `this` will render the template directly into the light DOM
        return this;
    }
}

const sms = {
    selections: [],
    elements: {
        frequency_radios: document.querySelector('cb-frequency-radios'),
        summary: document.querySelector('cb-summary'),
    }
};

class FrequencyRadios extends LitElementEjected {
    static get properties() {
        return {
            frequency: { type: String },
            selected: { type: Object }
        };
    }

    constructor() {
        super();
        this.frequency = '';
        this.options = [];
        this.plans = [
            {
                "frequency_name": "Delivery every 1 month",
                "frequency_interval": 1
            },
            {
                "frequency_name": "Delivery every 2 months",
                "frequency_interval": 2
            },
            {
                "frequency_name": "Delivery every 3 months",
                "frequency_interval": 3
            }
        ];
        // this.changeFrequency = this.changeFrequency.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();
        this.selected = this.plans[0];
    }

    render() {
        return html`
            <div class="cb__frequencies">
                <div class="cb__frequencies-header text-center">
                    <h3 class="cb__frequencies-title font-heading">${this.dataset.title}</h3>
                    <p class="cb__frequencies-text">${this.dataset.text}</p>
                </div>
                <div class="cb__frequencies-group">
                    ${this.plans.map(this.radioTemplate.bind(this))}
                </div>
                <p class="cb__frequencies-message text-center">${this.dataset.textBottom}</p>
            </div>
        `;
    }

    radioTemplate(plan, index) {
        const { frequency_name: name, frequency_interval: interval } = plan;
        const checked = (name === this.selected.frequency_name);

        return html`
            <label class="cb__frequency font-heading${(checked) ? ' is-selected' : ''}" for="freq-${index}">
                <input type="radio" 
                    name="frequency" 
                    id="freq-${index}" 
                    value="${name}" 
                    data-interval=${interval}
                    ?checked=${checked}
                    @click=${this.changeFrequency.bind(this, plan)}
                >
                <span class="cb__frequency-interval">${interval}</span>
                <span class="cb__frequency-text">${(interval === 1) ? 'Month' : 'Months'}</span>
            </label> 
        `;
    }

    changeFrequency(plan, event) {
        this.selected = plan;

        for (const card of document.querySelectorAll('cb-card')) {
            card.plan = plan.frequency_name;
            card.updatePriceAndPlan();
            card.updateSelection();
        }

        sms.elements.summary.frequency = plan.frequency_interval;
    }

    // updateOptions(){
        
    //     const { option1, option2, option3 } = this.dataset;
    //     (option1) ? this.plans.push(JSON.parse(option1)) : '';
    //     (option2) ? this.plans.push(JSON.parse(option2)) : '';
    //     (option3) ? this.plans.push(JSON.parse(option3)) : '';
    // }
}
customElements.define('cb-frequency-radios', FrequencyRadios);

class Summary extends LitElementEjected {
    static get properties() {
        return {
            selections: { type: Array },
            total: { type: Number },
            frequency: { type: Number },
        };
    }

    constructor() {
        super();
        this.selections = [];
        this.subtotal = 0;
        this.total = 0;
        this.discount = 0;
        this.min = 0;
        this.frequency = this.dataset.default;
        this.addToCart = this.addToCart.bind(this);
        this.remaining = 0;
        this.disabled = true;
    }

    connectedCallback() {
        super.connectedCallback();
        this.min = this.dataset.min;
        this.remaining = this.min;
    }

    render() {
        return html`
            <div class="cb__summary">
                <div class="cb__summary-blocks">
                    <div class="cb__summary-block">
                        <span class="cb__summary-label">Subtotal:</span>
                        <span class="cb__summary-value">$${this.subtotal}</span>
                    </div>

                    <div class="cb__summary-block">
                        <span class="cb__summary-label">Discount:</span>
                        <span class="cb__summary-value">$${this.discount}</span>
                    </div>

                    <div class="cb__summary-block">
                        <span class="cb__summary-label">Shipping:</span>
                        <span class="cb__summary-value">Free</span>
                    </div>

                    <div class="cb__summary-block">
                        <span class="cb__summary-label">Ships Every:</span>
                        <span class="cb__summary-value">${this.frequency} ${(Number(this.frequency) === 1) ? 'month' : 'months'}</span>
                    </div>

                    <div class="cb__summary-block">
                        <span class="cb__summary-label">Total:</span>
                        <span class="cb__summary-value">$${this.total}</span>
                    </div>

                    <div class="cb__summary-block button--block">
                        <button
                            class="cb__summary-button ${(this.disabled) ? 'btn' : 'push-btn'} inline-block"
                            ?disabled=${this.disabled}
                            @click=${this.addToCart}
                        >   
                            ${(this.disabled) ? 
                                html`<span>Add $${this.remaining} more</span>` 
                                : 
                                html`<span class="push-btn__surface">Add to Cart</span>`
                            }
                        </button>
                        
                    </div>
                </div>
            </div>
        `;
    }

    updateTotals() {
        this.selections = sms.selections;
        let total = 0;
        let discount = 0;

        this.selections.map(selection => {
            total += selection.price * selection.quantity;
            discount += selection.discount * selection.quantity;
        });

        this.subtotal = parseFloat(total + discount).toFixed(2);
        this.total = parseFloat(total).toFixed(2);
        this.discount = parseFloat(discount).toFixed(2);
        this.remaining = parseFloat(this.min - this.total).toFixed(2);

        this.disabled = (this.remaining > 0);
    }

    async addToCart(event) {
        const button = event.target;
        button.disabled = true;
        button.innerHTML = '<span class="push-btn__surface">Please wait...</span>';

        let selectionList = sms.selections.map(selection => ({
            id: selection.variant_id,
            quantity: selection.quantity,
            selling_plan: selection.selling_plan
        }));

        const data = {
            items: selectionList
        }

        try {
            const result = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            window.location = '/cart'
        }
        catch(error) {
            console.log('Error:', error)
        }
    }
}
customElements.define('cb-summary', Summary);

class ProductCard extends LitElementEjected {
    static get properties() {
        return {
            product: { type: Object },
            selected_plan: { type: Object },
            plan: { type: String },
            price: { type: Number },
            discount: { type: Number },
            total: { type: Number },
            quantity: { type: Number },
        };
    }

    constructor() {
        super();
        this.plans = [];
        this.plan = null;
        this.variant = '';
        this.total = 0;
        this.quantity = 0;
        this.price = 0;
        this.max = 0;
        this.increment = this.increment.bind(this);
        this.decrement = this.decrement.bind(this);
    }
    
    connectedCallback() {
        super.connectedCallback();
        this.setupProductInfo();
        this.updatePriceAndPlan();
    }

    render() {
        return html`
            <div class="cb__card">
                <div class="cb__card-block block--image" slot="image">
                    <div class="cb__card-image">
                        <img 
                            src="${this.product.featured_image.replace('.png', '_400x.png')}" 
                            alt="${this.product.title}"
                        >
                    </div>
                </div>

                <div class="cb__card-block block--info">
                    <span class="cb__card-title">${this.product.title}</span>
                    ${(this.selected_plan) ? html`<span class="cb__card-plan">${this.selected_plan.name}</span>` : ''}
                </div>

                <div class="cb__card-block block--price">
                    <div class="cb__card-price unit">
                        <span class="sr-only">Price:</span>
                        <span class="value">$${this.price} <span class="value-each">each</span></span>
                    </div>
                </div>

                <div class="cb__card-block block--controls">
                    <div class="cb__card-controls">
                        <button class="cb__card-button decrement" @click=${this.decrement}>-</button>
                        <input class="cb__card-quantity" type="number" value="${this.quantity}" min="0" max="${this.max}" readonly>
                        <button class="cb__card-button increment" @click=${this.increment}>+</button>
                    </div>
                    ${(this.quantity === this.max) ? this.limitMessage() : ''}
                </div>

                <div class="cb__card-block block--total">
                    <div class="cb__card-price total">
                        <span class="sr-only">Total</span>
                        <span class="value">$${this.total}</span>
                    </div>
                </div>
            </div>
        `;
    }

    async setupProductInfo() {
        this.product = JSON.parse(this.dataset.product);
        this.variants = this.product.variants;
        this.dataset.product = '';

        this.variant = (this.product.type === 'Bars') ? this.variants.find(variant => variant.title.indexOf('Single') > -1) : this.variants[0];
        this.max = (this.variant.available) ? 100 : 0; 

        if (this.product.selling_plan_groups.length > 0) {
            this.product.selling_plan_groups.map(group => {
                if (group.selling_plans.length > 0) {
                    this.plans.push(group.selling_plans[0]);
                }
            });
        }

        this.updatePriceAndPlan();
    }

    updatePriceAndPlan() {    
        this.selected_plan = (this.plan) ? this.plans.find(plan => plan.name === this.plan) : this.plans[0];

        // fix for mismatched plan names        
        if (this.plan && this.selected_plan === undefined) {
            let test = this.plan.replace('Delivery every ', '').replace('months', 'month').trim();
            this.selected_plan = this.plans.find(plan => plan.name.indexOf(test) > -1);
        }

        const percentage = (this.selected_plan && this.selected_plan.price_adjustments.length > 0) ? this.selected_plan.price_adjustments[0].value / 100 : 0;
        let price = this.variant.price / 100;
        const discount = price * percentage;

        if (percentage > 0) {
            price = price - discount;
        }
        
        this.price = parseFloat(price).toFixed(2);
        this.discount = parseFloat(discount).toFixed(2);
        this.total = parseFloat(this.price * this.quantity).toFixed(2);
    }

    increment() {
        if (this.quantity < this.max) {
            this.quantity++;
            this.updateSelection();
        }
    }

    decrement() {
        if (this.quantity > 0) {
            this.quantity--;
            this.updateSelection();
        }
    }

    updateSelection() {
        this.updatePriceAndPlan();

        const index = sms.selections.findIndex(s => (s.product_id === this.product.id));
        if (index === -1 && this.quantity === 0) return;

        const object = {
            title: this.product.title,
            product_id: this.product.id,
            variant_id: this.variant.id,
            variant_title: this.variant.title,
            quantity: this.quantity,
            price: this.price,
            discount: this.discount,
            selling_plan: this.selected_plan.id
        };

        let selections = Array.from(sms.selections);

        if (index !== -1) {
            if (this.quantity === 0) {
                selections.splice(index, 1);
            } else {
                selections[index] = object;
            }
        } else {
            if (this.quantity> 0) {
               selections.push(object);
            }
        }

        sms.selections = selections;
        sms.elements.summary.updateTotals();
    }

    limitMessage() {
        return html`
            <span class="cb__card-message">Maximum reached</span>
        `;
    }
}
customElements.define('cb-card', ProductCard);

// class ClubBundle extends LitElementEjected {
//     static get properties() {
//         return {
//             products: { type: Array },
//             selections: { type: Array }
//         };
//     }

//     constructor() {
//         super();
//         this.products = [];
//         this.selections = [];
//     }

//     connectedCallback() {
//         super.connectedCallback();
//         this.fetchProducts();
//     }
// }

// class ProductCard extends HTMLElement {
//     constructor() {
//         super();
//         this.increment = this.increment.bind(this);
//         this.decrement = this.decrement.bind(this);
//         this.changePlan = this.changePlan.bind(this);
//     }

//     connectedCallback() {
//         this.cacheElements();
//         this.bindEvents();
//         this.initializeValues();
//     }

//     cacheElements() {
//         this.incrementBtn = this.querySelector('.cb__product-button.increment');
//         this.decrementBtn = this.querySelector('.cb__product-button.decrement');
//         this.priceEl = this.querySelector('.cb__product-price.unit .value');
//         this.totalEl = this.querySelector('.cb__product-price.total .value');
//         this.planSelect = this.querySelector('.cb__product-plans');
//         this.input = this.querySelector('.cb__product-quantity');
//     }

//     bindEvents() {
//         this.planSelect.addEventListener('change', this.changePlan);
//         this.incrementBtn.addEventListener('click', this.increment);
//         this.decrementBtn.addEventListener('click', this.decrement);
//     }

//     initializeValues() {
//         this.quantity = 0;
//         this.price = this.parsePrice(this.priceEl.innerHTML);
//     }

//     parsePrice(priceString) {
//         return parseFloat(priceString.replace('$', ''));
//     }

//     changePlan(event) {
//         const selectedOption = event.target.options[event.target.selectedIndex];
//         this.price = parseFloat(selectedOption.getAttribute('data-price')).toFixed(2);
//         this.updatePrice();
//     }

//     increment() {
//         this.input.value = parseInt(this.input.value) + 1;
//         this.quantity = this.input.value;
//         this.updatePrice();
//     }

//     decrement() {
//         if (this.input.value > 0) {
//             this.input.value = parseInt(this.input.value) - 1;
//             this.quantity = this.input.value;
//             this.updatePrice();
//         }
//     }

//     updatePrice() {
//         this.priceEl.innerHTML = `$${this.price}`;
//         this.totalEl.innerHTML = `$${(this.price * this.quantity).toFixed(2)}`;
//     }
// }

// customElements.define('cb-product-card', ProductCard);
